module.exports = __webpack_public_path__ + "img/pcr4.cc7ad479.png";